module.exports = __webpack_public_path__ + "static/sander_nagtegaal-9fe9dfbabca2fc35dd473e4e3929faac.jpg";